import {ManagementTransformBase} from "../TranformBase";

import {
  LocaleInfoRecordModel,
  LocaleInfoListModel,
} from "@/api/models/actions/locales";
import {LocaleInfo} from "@/api/services";

export class LocalesTransform extends ManagementTransformBase<
  LocaleInfoRecordModel,
  false
> {
  public makeRecordModel(dto: LocaleInfo): LocaleInfoRecordModel {
    const model: LocaleInfoRecordModel = {
      identifier: dto.identifier,
      title: dto.title,
    };

    return model;
  }

  public makeListModel(dto: LocaleInfo[]): LocaleInfoListModel {
    const model: LocaleInfoListModel = {
      records: dto?.map(item => this.makeRecordModel(item)),
    };

    return model;
  }
}

export const localesTransform = new LocalesTransform();
